import { BriefcaseIcon, SunriseIcon, UsersIcon } from 'lucide-react';

export const empowerAreas = [
  { label: 'In Business', icon: BriefcaseIcon },
  { label: 'In Life', icon: SunriseIcon },
  { label: 'In the Next Generation', icon: UsersIcon },
];

export const stats = [
  { value: '30', label: 'Years in Marketing' },
  { value: '15', label: 'Years Coaching High School Football' },
  { value: 'Thousands', label: 'Reached From the Stage' },
];

export const facts = [
  'Part of the team that invented the domain name appraisal algorithm.',
  'One of the largest opt-in email marketers in the country.',
  'Helped build the largest database of opt-in mobile numbers at that time.',
];

export const speakingTopics = [
  'Marketing That Converts',
  'AI for Business Owners',
  'Automation & Streamlining',
  'Mindset & Motivation',
  'Mentoring Young People',
];

export const consultingServices = [
  'Strategy sessions',
  'Process & automation review',
  'AI implementation roadmap',
  'Marketing audit',
];
